import {createReducer} from "redux-act";
import {
	fetchRounds,
	fetchRoundsFailed,
	fetchRoundsSuccess,
	selectRound,
	setGameView,
} from "modules/actions";
import {GameView, Stage, RequestStateType, RoundStatus, TournamentStatus} from "modules/enums";

export interface ITournament {
	id: number;
	venueName: string;
	venueId: number;
	homeSquadId: number;
	awaySquadId: number;
	homeSquadName: string;
	awaySquadName: string;
	homeScore: number | null;
	awayScore: number | null;
	homePenaltyScore: number | null;
	awayPenaltyScore: number | null;
	status: TournamentStatus;
	date: string;
	bracketId: number;
	matchcentreUrl: string;
	isThirdPlacePlayOff?: boolean;
}

export interface IRound {
	id: number;
	stage: Stage;
	status: RoundStatus;
	startDate: string;
	endDate: string;
	tournaments: ITournament[];
}

export interface INavigateRound extends IRound {
	isShowTimer: boolean;
	isDisabled?: boolean;
	points?: number;
	title?: string;
	className?: string;
}

export interface IRoundReducer {
	rounds: IRound[];
	selectedRound: number | null;
	requestState: RequestStateType;
	gameView: GameView;
}

const defaultState: IRoundReducer = {
	rounds: [],
	selectedRound: null,
	requestState: RequestStateType.Idle,
	gameView: GameView.List,
};

const onSelectRound = (state: IRoundReducer, payload: number | null) => ({
	...state,
	selectedRound: payload,
});

const onFetchRounds = (state: IRoundReducer) => ({
	...state,
	requestState: RequestStateType.Loading,
});

const onFetchRoundsSuccess = (state: IRoundReducer, payload: IRound[]) => ({
	...state,
	rounds: payload,
	requestState: RequestStateType.Success,
});

const onFetchRoundsFailed = (state: IRoundReducer) => ({
	...state,
	requestState: RequestStateType.Error,
});

export const rounds = createReducer({}, defaultState)
	.on(fetchRounds, onFetchRounds)
	.on(fetchRoundsSuccess, onFetchRoundsSuccess)
	.on(fetchRoundsFailed, onFetchRoundsFailed)
	.on(selectRound, onSelectRound)
	.on(setGameView, (state, payload) => ({
		...state,
		gameView: payload,
	}));
